<style lang="scss" src='./ChangePassword.scss' scoped></style>
<template src="./ChangePassword.html"></template>

<script>
import Vue from 'vue';
import CommonComponent from '@/components/utils/CommonComponent.vue';
import GwPassword from '@/components/gwPassword/GwPassword.vue';

import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, password } from 'vee-validate/dist/rules';
import { ChangePassword } from '@/api/api';

extend('required', required);


export default {
  name: 'ChangePassword',
  extends: CommonComponent,
  components: {
    ValidationProvider,
    ValidationObserver,
    GwPassword,
  },

  data() {
    return {
      currentPassword: null,
      newPassword: null,
      confirmationPassword: null,
      loading: false,
    };
  },

  computed: {
  },

  watch: {
  },

  methods: {

    reset() {
      this.currentPassword = null;
      this.newPassword = null;
      this.confirmationPassword = null;
      this.$refs.validator.reset();
      this.loading = false;
    },

    async changePassword () {
      const validForm = await this.$refs.validator.validate().then((v) => v);
      if (validForm) {
        this.loading = true;
        await ChangePassword(this.currentPassword, this.newPassword)
            .then((response) => {
                Vue.notify({ type: 'success', text: this.$t('settings.passwordUpdated') });
                this.reset();
                this.$router.go(-1);
            }).catch((err) => {
              this.loading = false;
            });
      }
    },

  },
  beforeCreate() {
    extend('password', {
      params: ['target'],
      validate(value, { target }) {
        return value === target;
      },
      message: this.$t('login.passwordNotMatch')
    });
  },
  mounted() {
    this.setShowMenu(false);
    this.setShowBackground(false);
  },
};

</script>
